var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBearButter = function SvgBearButter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FABC50",
    stroke: "#D49A35",
    strokeWidth: 1.317,
    d: "M7.037 13.72a1.17 1.17 0 0 1-1.64-.4L3.186 8.952c-.38-.623-1.539-.732-1.833-1.216-.747-1.229.54-3.375 2.876-4.795s4.834-1.575 5.581-.346c.3.494-.143 1.633.219 2.227l2.884 3.997c.343.563.156 1.236-.44 1.598z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CBBE0B",
    d: "M7.791 4.864c.407-.089.832.02 1.146.294l1.82 1.587c.47.41.589 1.094.282 1.638l-.316.562a1.3 1.3 0 0 1-.452.472l-2.318 1.44a1.317 1.317 0 0 1-1.836-.46L4.67 7.89a1.32 1.32 0 0 1 .078-1.437l.514-.701c.19-.26.469-.44.783-.508z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5.114,
    height: 4.847,
    x: 9.258,
    y: 3.169,
    fill: "#FFF73B",
    rx: 1.317,
    transform: "rotate(60 9.258 3.17)"
  })));
};
export default SvgBearButter;